import React from "react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import clsx from "clsx"

import { SectionOrderGame } from "services/game/type"

interface SortableRowProps {
  game: SectionOrderGame
  positionLabel: number
  onRemove?: () => void
}

export const SortableRow = ({ game, positionLabel, onRemove }: SortableRowProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: game.identifier })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1
  }

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className={clsx(
        "odd:bg-black/[0.02] dark:odd:bg-white/[0.05]",
        isDragging && "bg-[rgba(132,_0,_168,_0.08)] dark:bg-[rgba(132,_0,_168,_0.15)]"
      )}
    >
      <td className="px-3 py-2 font-mono text-xs opacity-70">{positionLabel}</td>
      <td className="px-3 py-2">
        <button
          type="button"
          {...attributes}
          {...listeners}
          className="cursor-grab active:cursor-grabbing p-1 opacity-60 hover:opacity-100"
          aria-label="Drag to reorder"
          title="Drag to reorder"
        >
          ⋮⋮
        </button>
      </td>
      <td className="px-3 py-2">
        {game.image_vertical || game.image ? (
          <img src={game.image_vertical || game.image || ""} alt={game.title} className="h-16 w-auto rounded" />
        ) : (
          <div className="h-16 w-12 rounded bg-black/[0.05] dark:bg-white/[0.05]" />
        )}
      </td>
      <td className="px-3 py-2">{game.title}</td>
      <td className="px-3 py-2">{game.gameProvider?.title ?? game.provider}</td>
      <td className="px-3 py-2 text-center">
        <span
          className={clsx(
            "inline-block px-2 py-0.5 rounded text-xs",
            game.enabled ? "bg-[rgba(16,185,129,0.12)] text-[rgba(16,185,129,1)]" : "bg-[rgba(245,158,11,0.12)] text-[rgba(245,158,11,1)]"
          )}
        >
          {game.enabled ? "enabled" : "disabled"}
        </span>
      </td>
      {onRemove && (
        <td className="px-3 py-2 text-center">
          <button
            type="button"
            onClick={onRemove}
            className="text-sm opacity-60 hover:opacity-100 hover:text-red-500"
            aria-label="Remove from category"
            title="Remove from category"
          >
            ×
          </button>
        </td>
      )}
    </tr>
  )
}
